import EdgeScript from "src/component/props/PropsGGEditor/exec/EdgeScript";

export default EdgeScript;
